import styled from 'styled-components';

const LabelStyled = styled.span`
  display: inline-block;
`;

export default LabelStyled;
